import { render } from "./ActiveInvoices.vue?vue&type=template&id=22bddf9a"
import script from "./ActiveInvoices.vue?vue&type=script&lang=js"
export * from "./ActiveInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__